import React from "react";
import styles from "../Hero_2/Hero_2.module.css";

// importing heroSectionData from json file
import heroSection from "../../Data/RO-landing.json";
const heroSectionData = heroSection[0]?.heroSection;

const Hero_2 = () => {
  return (
    <div className={styles.container}>
      <h2 className={styles.heading}>{heroSectionData.heading}</h2>
      <div className={styles.notes}>
        <ul>
          <li>
            {heroSectionData.notes.map((elem, index) => {
              return (
                <>
                  <h3> * {elem}</h3>
                </>
              );
            })}
          </li>
        </ul>
      </div>
    </div>
  );
};

export default Hero_2;
